import { lighten } from '@material-ui/core/styles';

export const themeColorTokens = {
  white: '#FFFFFF',
  black: '#000000',
  mintGreen: '#586c53',
  zincYellow: '#000000',
  slateBlueGrey: '#00334e',
  shellLightBackground: '#C3C3C3',
  surfaceMuted: '#F9F9F9',
  surfaceSoft: '#FAF6F6',
  textPrimary: '#2e343b',
  cobaltBlue: '#1070CA',
  swooshOrange: '#f97316',
  brightMango: '#a6414f',
  warmGrey: '#8a8682',
  brightTeal: '#52bfa8',
  border: '#DFE3E8',
  borderSubtle: '#DEE2E6',
  borderLight: '#EEE',
  overlayStrong: 'rgba(0, 0, 0, 0.7)',
  overlaySubtle: 'rgba(0, 0, 0, 0.03)',
  chartLabelBackground: 'rgba(200, 200, 200, 0.5)',
  forestGreenDark: '#00783E',
  notificationWarning: '#D14343',
  notificationFeature: '#5243AA',
  commonNeutral: '#E4E7EB',
  commonMuted: '#9EA0A4',
  successLight: '#F1FAF5',
  infoLight: '#f3eed5',
  infoDark: '#007489',
  warningLight: '#FDF8F3',
  warningDark: '#95591E',
  textDisabled: '#A6B1BB',
  backgroundDark: '#172B4D',
  notificationBorder: '#83909f',
  adgileDarkGrey: '#585858',
  chipText: '#425A70',
  chipHoverBackground: '#EDF0F2',
  tooltipText: 'rgba(0, 0, 0, 0.87)',
};

export const themeBrandingTokens = {
  catalystLightLogo: '/images/logos/adgile-logo-main-reversed.svg',
  catalystDarkLogo: '/images/logos/adgile-catalyst-dark.png',
  boltLogo: '/images/logos/adgile-bolt-rgb.png',
  nlogicLogo: '/images/logos/nlogic-white.png',
  connectedWorldIllustration: '/images/connected_world.svg',
  emptyStateIllustration: '/images/empty.png',
  notFoundIllustration: '/images/not_found.png',
  imageNotFoundIllustration: '/images/imagenotfound.png',
  missingAdvertThumbnail: '/images/missing_advert_thumbnail.png',
  missingAdvertThumbnailWords: '/images/missing_advert_thumbnail_words.png',
  missingAdvertThumbnailPaleWords: '/images/missing_advert_thumbnail_pale_words.png',
};

// This will be the logo colour
// Swoosh Orange: #f97316

// This is all our text colour
// Slate Grey: #2e343b

// This is our highlight colour
// Bright Mango: #a6414f
const palette = {
  common: {
    black: themeColorTokens.black,
    white: themeColorTokens.white,
    neutral: themeColorTokens.commonNeutral,
    muted: themeColorTokens.commonMuted,
    link: themeColorTokens.brightTeal,
  },
  primary: {
    main: themeColorTokens.slateBlueGrey,
    light: lighten(themeColorTokens.shellLightBackground, 0.8),
  },
  secondary: {
    contrastText: themeColorTokens.white,
    main: themeColorTokens.brightMango,
  },
  success: {
    contrastText: themeColorTokens.white,
    main: themeColorTokens.mintGreen,
    light: themeColorTokens.successLight,
    dark: themeColorTokens.forestGreenDark,
  },
  info: {
    contrastText: themeColorTokens.white,
    main: themeColorTokens.cobaltBlue,
    light: themeColorTokens.infoLight,
    dark: themeColorTokens.infoDark,
  },
  warning: {
    contrastText: themeColorTokens.white,
    main: themeColorTokens.zincYellow,
    light: themeColorTokens.warningLight,
    dark: themeColorTokens.warningDark,
  },
  danger: {
    contrastText: themeColorTokens.white,
    main: themeColorTokens.brightMango,
  },
  error: {
    contrastText: themeColorTokens.white,
    main: themeColorTokens.brightMango,
  },
  text: {
    primary: themeColorTokens.textPrimary,
    secondary: themeColorTokens.slateBlueGrey,
    disabled: themeColorTokens.textDisabled,
  },
  background: {
    default: lighten(themeColorTokens.shellLightBackground, 0.7),
    dark: themeColorTokens.backgroundDark,
    paper: themeColorTokens.white,
  },
  border: themeColorTokens.border,
  notificationBorder: themeColorTokens.notificationBorder,
  divider: themeColorTokens.border,
  adgile: {
    slateGrey: themeColorTokens.textPrimary,
    blueGrey: themeColorTokens.slateBlueGrey,
    warmGrey: themeColorTokens.warmGrey,
    swooshOrange: themeColorTokens.swooshOrange,
    brightTeal: themeColorTokens.brightTeal,
    brightMango: themeColorTokens.brightMango,
    surfaceMuted: themeColorTokens.surfaceMuted,
    surfaceSoft: themeColorTokens.surfaceSoft,
    borderSubtle: themeColorTokens.borderSubtle,
    borderLight: themeColorTokens.borderLight,
    overlayStrong: themeColorTokens.overlayStrong,
    overlaySubtle: themeColorTokens.overlaySubtle,
    black: themeColorTokens.black,
    darkGrey: themeColorTokens.adgileDarkGrey,
    lightGrey: themeColorTokens.shellLightBackground,
    white: themeColorTokens.white,
  },
};

export const sidebarPalette = {
  // ...palette,
  primary: {
    main: themeColorTokens.swooshOrange,
    light: lighten(themeColorTokens.shellLightBackground, 0.8),
  },
  secondary: {
    main: themeColorTokens.swooshOrange,
    light: lighten(themeColorTokens.shellLightBackground, 0.8),
  },
  background: {
    default: themeColorTokens.slateBlueGrey,
    paper: themeColorTokens.slateBlueGrey,
  },
  text: {
    primary: themeColorTokens.textPrimary,
    secondary: themeColorTokens.white,
  },
};

export const titlePalette = {
  // ...palette,
  primary: {
    main: themeColorTokens.white,
    light: lighten(themeColorTokens.shellLightBackground, 0.8),
  },
  secondary: {
    main: themeColorTokens.brightMango,
    light: lighten(themeColorTokens.shellLightBackground, 0.8),
  },
  background: {
    default: themeColorTokens.slateBlueGrey,
  },
  text: {
    primary: themeColorTokens.textPrimary,
    secondary: themeColorTokens.white,
  },
};

export default palette;

